import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=260181cc&scoped=true"
import script from "./BasePopup.vue?vue&type=script&lang=js"
export * from "./BasePopup.vue?vue&type=script&lang=js"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=260181cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260181cc",
  null
  
)

export default component.exports